<div class="field">
    <div class="value" [ngClass]="{
        'changed': modelValue.isFieldChanged(property),
        'error': hasErrors()
    }">
        <input type="checkbox" [(ngModel)]="modelValue.currentState[property]" [disabled]="isDisabled"
            (input)="handleManualChange()" (change)="handleValueChange()"/>
    </div>
    <calibration-set-table-field-attributes *ngIf="!hideAttributeButtons" [identifiers]="getCalibrationSetTableFieldIdentifier()"
        [showPopover]="true"
        [attributePopupTitleDetails]="attributePopupTitleDetails">
    </calibration-set-table-field-attributes>
</div>
